import { render, staticRenderFns } from "./_ProductOrderButton.vue?vue&type=template&id=3ec90e18&scoped=true&"
import script from "./_ProductOrderButton.vue?vue&type=script&lang=js&"
export * from "./_ProductOrderButton.vue?vue&type=script&lang=js&"
import style0 from "./_ProductOrderButton.vue?vue&type=style&index=0&id=3ec90e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec90e18",
  null
  
)

export default component.exports